import React, { useEffect } from 'react';
import Icon from './Icon';
import './Toast.css';

const Toast = ({ message, type = 'info', duration = 4000, onClose }) => {
    useEffect(() => {
        if (duration > 0) {
            const timer = setTimeout(() => {
                onClose();
            }, duration);

            return () => clearTimeout(timer);
        }
    }, [duration, onClose]);

    const getIcon = () => {
        switch (type) {
            case 'success':
                return 'CheckCircle';
            case 'error':
                return 'XCircle';
            case 'warning':
                return 'AlertTriangle';
            default:
                return 'Info';
        }
    };

    return (
        <div className={`toast toast-${type}`}>
            <div className="toast-icon">
                <Icon name={getIcon()} size={20} />
            </div>
            <div className="toast-message">{message}</div>
            <button className="toast-close" onClick={onClose}>
                <Icon name="X" size={18} />
            </button>
        </div>
    );
};

export default Toast;
